import { render } from "./UnitList.vue?vue&type=template&id=2ef5e7b6&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"

import "./UnitList.vue?vue&type=style&index=0&id=2ef5e7b6&scoped=true&lang=stylus"
import "./UnitList.vue?vue&type=style&index=1&id=2ef5e7b6&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2025\\tokyo-shoseki\\r8\\08rk_sikk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef5e7b6"]])

export default __exports__